import React, { Component } from "react";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';
//import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import IconButton from '@material-ui/core/IconButton';

class Documentation extends Component {
	constructor(props) {
		super(props);
		this.state= {
			dialogOpen: false
		}
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.renderDocList = this.renderDocList.bind(this);
	}
	
	handleOpen(){
		this.setState({dialogOpen: true});
	};
	
	handleClose(){
		this.setState({dialogOpen: false});
	};
	
//	handleClick(id){
//		console.log("handleClick("+id+")");
		//var index = id.split("_");
		//this.handleClose();
		//this.props.action(index[0], index[1]);
//	}
	
	renderDocList(){
		let docList = this.props.customer.documentation.sort( (a,b) => a.filename.localeCompare(b.filename)).map( attachment => <li><a target="_blank" href={process.env.REACT_APP_serverURL+"/documents-0.0.1/document/"+attachment.id+"/content?access_token="+this.props.accessToken}>{attachment.filename}</a></li>)
		return <ul>{docList}</ul>;
	}

	render() {
		return (
		<span>
			<Dialog open={this.state.dialogOpen} onClose={this.handleClose} fullWidth={true} maxWidth = {'md'}>
				<DialogTitle>Documentation</DialogTitle>
				<DialogContent dividers>
					<DialogContentText>
					{this.renderDocList()}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleClose} color="primary">
					CLOSE
					</Button>
				</DialogActions>
			</Dialog>
			<Tooltip title="Download documentation"><Icon style={{cursor: "pointer"}} onClick={() => { this.handleOpen(); }}><IconButton color="inherit" aria-label="Full text"><GetAppOutlinedIcon /></IconButton></Icon></Tooltip>
		</span>
		);
	}
}

export default Documentation;